import Tag from '../../../fragments/Tag'
import AttorneysTags from './AttorneysTags'
import LawFirmAddress from './LawFirmAddress'
import AttorneyStatusContainer from './AttorneyStatusContainer'
import DeleteItem from '../Shared/DeleteItem'
import Item from '../Shared/Item'
import PrimaryCheckbox from '../Shared/PrimaryCheckbox'
import CardGrey from '../../../common/CardGrey'
import classes from '../Shared/Item.module.css'
import GroupContainer from '../GroupNew/GroupContainer'
import DefaultUpdater from '../../../common/DefaultUpdater'
import { attorneyLegalStatusOptions, attorneyStatusOptionsPayerTypes } from '../../../../lib/systemData'
import PracticesUpload from '../procodocs/practicesupload/PracticesUpload'
import { formatDateLocal } from '../../../../lib/script'
import { useUserTabEditPermissionDisabled } from '../../../../lib/usersPermissions'
import PayerTypeStatusGlobalModal from '../../../common/modal/PayerTypeStatusGlobalModal'
import LawFirmNotVerified from './LawFirmNotVerified'
import CollectionRep from '../negotiation/CollectionRep'
import { useMemo } from 'react'

const AttorneyDetailItem = ({data, lastChild, apiCase, folder}) => {  
    let userPermissionUpload = useUserTabEditPermissionDisabled('procodocs_documents_upload')
    let userPermissionUpdate = useUserTabEditPermissionDisabled('procodocs_documents_update')
    const attorneyPayerStatusOptionsData = useMemo(() => attorneyStatusOptionsPayerTypes(), [])
    const attorneyLegalStatusOptionsData = useMemo(() => attorneyLegalStatusOptions(), [])
    const resolvedSalesRep = data?.law_firm?.prefered_poc_rep || data?.law_firm?.poc_rep

    return <Item data={data} mainItem={data.is_managing_attorney} type={apiCase} folder={'attorneys'} lastChild={lastChild}>
        <div className={classes.item_header}>
            {data.law_firm && <>
                <div>
                    <div className={classes.name}>
                        <Tag type={'note'}>{data.law_firm.code}</Tag>
                        <h2>{data.law_firm.name}</h2>
                        <LawFirmNotVerified lawFirm={data.law_firm}/>
                        <AttorneysTags data={data.law_firm.options} outOfState={data.location}/>                                                
                    </div>
                    {(data.location?.contact_information || data.law_firm.contact_information) && <div className={classes.location}>
                        <i className='ti ti-building-skyscraper'></i>                  
                        <LawFirmAddress lawFirmData={data}/>                        
                    </div>}
                </div>
                <div className={classes.header_controls}>
                    <PayerTypeStatusGlobalModal date={data.payer_status_date} user={data.payer_status_by}>                        
                        <DefaultUpdater type={'select'} value={data.payer_status_id} options={attorneyPayerStatusOptionsData} label={'Attorney Payer Status'} identifier={{type: apiCase, field: 'payer_status_id', type_id: data.id, folder: 'attorneys'}} extraOptions={{hasRemove: true}}/>
                    </PayerTypeStatusGlobalModal>  
                    <AttorneyStatusContainer data={data}/>
                    <DefaultUpdater type={'select'} value={data.legal_status_id} options={attorneyLegalStatusOptionsData} label={'Atty Legal Status'} identifier={{type: apiCase, field: 'legal_status_id', type_id: data.id, folder: 'attorneys'}} extraOptions={{hasRemove: true}}/>
                    <DefaultUpdater type={'input'} value={data.case_number} label={'Atty Case ID'} identifier={{type: apiCase, field: 'case_number', type_id: data.id, folder: 'attorneys'}} />
                 
                    <DeleteItem data={data} type={apiCase} folder={'attorneys'} label={'attorney'}/>
                    
                </div>
            </>}
        </div>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>
                
                <div className={classes.item_body}>
                    <div className={`${classes.row} ${classes.row_align_center}`}>
                        <CardGrey>
                            <PrimaryCheckbox data={data} label={'Primary Attorney'} folder={'attorneys'} apiCase={apiCase} propertyName={'is_managing_attorney'}/>
                        </CardGrey>
                        {resolvedSalesRep?.name && <CollectionRep label={'POC'} value={resolvedSalesRep.name} contact_info={resolvedSalesRep} type={'Representative'} maxWidth={250}/>}
                    </div>

                    <div className={classes.row}>
                        <div className={classes.row_item_full}>
                            <CardGrey>
                                {/* Location  */}
                                <div className={classes.group_container}>
                                    <GroupContainer data={data} dataId={data.id} smsMail={'Law Firm'} label={'location'} folder={'attorneys'} fieldsData={{fields: ['location_id', 'location'], fieldId: 'location_id', fieldobj: 'location', group: 'locations', inputLabel: 'Location'}} apiCase={apiCase}/>
                                </div>                                
                                
                                {/* Attorney  */}
                                <div className={classes.group_container}>
                                    <GroupContainer data={data} dataId={data.id} smsMail={'Attorney'} label={'attorney'} folder={'attorneys'} fieldsData={{fields: ['attorney_id', 'attorney'], fieldId: 'attorney_id', fieldobj: 'attorney', group: 'attorneys', inputLabel: 'Attorney Name'}} apiCase={apiCase}/>
                                </div>

                                {/* Case Manager  */}
                                <div className={classes.group_container}>
                                    <GroupContainer data={data} dataId={data.id} smsMail={'Case Manager'} label={'case_manager'} folder={'attorneys'} fieldsData={{fields: ['case_manager_id', 'case_manager'], fieldId: 'case_manager_id', fieldobj: 'case_manager', group: 'case_managers', inputLabel: 'Case manager'}} apiCase={apiCase}/>
                                </div>
                            </CardGrey>
                        </div>
                    </div>
                    
                    
                </div>
                
            </div>

            <div className={`${classes.item_right_atty}`}>
                <PracticesUpload caseAttorneyId={data.id} attyData={data} uploadPermission={userPermissionUpload} updatePermission={userPermissionUpdate}/>
    
            </div> 
        </div>   
        {data.status_id && data.status_id == 5 && <div className={classes.item_footer}>
            <h3 className={classes.drop_reason_header}>Attorney dropped on {formatDateLocal(data.drop_date)} </h3>
            <p className={classes.drop_reason_body}>{data.drop_reason}</p>     
        </div>}
    </Item>
}

export default AttorneyDetailItem